export const THEME_SEPARATOR = '|'

export function parseThemesFromInput(value) {
  if (!value || typeof value !== 'string') {
    return []
  }

  return value
    .split(THEME_SEPARATOR)
    .map((theme) => theme.trim())
    .filter(Boolean)
}

export function formatThemesForInput(themes) {
  if (!Array.isArray(themes) || themes.length === 0) {
    return ''
  }

  return themes.join(THEME_SEPARATOR)
}

export function formatThemesForDisplay(themes) {
  if (!Array.isArray(themes) || themes.length === 0) {
    return ''
  }

  return themes.join(` ${THEME_SEPARATOR} `)
}
